import { PropTypes } from 'prop-types';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { Button } from '@material-ui/core';
import { useState } from 'react';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

CreateKnowledgeGroupActionButton.propTypes = {
    hasEditFieldPermissions: PropTypes.bool,
    detailTicket: PropTypes.any,
    userDetail: PropTypes.any,
    isDisableBtnSaveTicket: PropTypes.any,
    submitEditTicket: PropTypes.any,
    displayMode: PropTypes.any,
    setDisplayMode: PropTypes.any,
    isEdited: PropTypes.bool,
    cancelEditTicket: PropTypes.any,
    isDisableButtonDraft: PropTypes.any,
    onClickDraft: PropTypes.any,
    setIsShowDialogRestoreTicket: PropTypes.any,
    isDuplicate: PropTypes.any,
};

export default function CreateKnowledgeGroupActionButton(props) {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const {
        hasEditFieldPermissions,
        detailTicket,
        userDetail,
        isDisableBtnSaveTicket,
        submitEditTicket,
        displayMode,
        setDisplayMode,
        isEdited,
        cancelEditTicket,
        isDisableButtonDraft,
        onClickDraft,
        setIsShowDialogRestoreTicket,
        isDuplicate
    } = props;

    const [displayPopupConfirmCancel, setDisplayPopupConfirmCancel] = useState(false);

    const isDisplayButtonCancelEdit = () => {
        return (
            !Utils.isEmptyObject(detailTicket) &&
            Utils.isEmptyString(detailTicket?.deletedAt) &&
            displayMode === Constant.DISPLAY_MODE.EDIT &&
            !isDuplicate
        );
    };

    const isDisplayButtonSaveDraft = () => {
        // If duplicate, always show button
        if (isDuplicate) {
            return true;
        }
        
        // Original logic for other cases
        return (
            (displayMode === Constant.DISPLAY_MODE.EDIT &&
                userDetail.id === detailTicket?.creator &&
                Utils.isEmptyString(detailTicket?.deletedAt)) ||
            Utils.isEmptyObject(detailTicket)
        );
    };

    const isDisplayButtonSaveEdit = () => {
        return (
            displayMode === Constant.DISPLAY_MODE.EDIT &&
            Utils.isEmptyString(detailTicket?.deletedAt)
        );
    };

    const handleClickBtnCancelEdit = () => {
        if (!isEdited) {
            return setDisplayMode(Constant.DISPLAY_MODE.VIEW);
        }

        setDisplayPopupConfirmCancel(true);
    };

    const handleConfirmCancelEdit = () => {
        setDisplayPopupConfirmCancel(false);
        cancelEditTicket();
        setDisplayMode(Constant.DISPLAY_MODE.VIEW);
    };

    const isDisplayButtonRestore = () => {
        return !Utils.isEmptyString(detailTicket?.deletedAt);
    };

    const isDisplayAnyButton =
        isDisplayButtonCancelEdit() ||
        isDisplayButtonSaveDraft() ||
        isDisplayButtonSaveEdit() || 
        isDisplayButtonRestore()

    if (!isDisplayAnyButton) return <></>;

    return (
        (hasEditFieldPermissions) && (
            <div className="btnHead">
                <div className="btnHead-btn">
                    {/* Cancel */}
                    {isDisplayButtonCancelEdit() && (
                        <Button
                            className="btn-send btn-outline-primary btn-hg32"
                            variant="contained"
                            onClick={() => handleClickBtnCancelEdit()}
                        >
                            {trI18n('BUTTON-CANCEL-EDIT')}
                        </Button>
                    )}

                    {/* Back to draft */}
                    {isDisplayButtonSaveDraft() && (
                        <Button
                            className="btn-send btn-outline-primary btn-hg32 back-to-draft"
                            variant="contained"
                            color="primary"
                            disabled={isDisableButtonDraft}
                            onClick={() => onClickDraft()}
                        >
                            {trI18n('CM-BUTTON-SAVE-AS-DRAFT')}
                        </Button>
                    )}

                    {/* Save */}
                    {isDisplayButtonSaveEdit() && (
                        <Button
                            className="btn-send btn-primary btn-hg32"
                            variant="contained"
                            color="primary"
                            onClick={e => submitEditTicket()}
                            disabled={isDisableBtnSaveTicket}
                        >
                            {!Utils.isEmptyObject(detailTicket) && !isDuplicate ? trI18n('SENT_TO_PUBLIC') : trI18n('COMBTN011')}
                        </Button>
                    )}

                    {/* Restore */}
                    {isDisplayButtonRestore() && (
                        <div className="btnHead-btn">
                            <Button
                                className="btn-send btn-outline-primary btn-hg32"
                                variant="contained"
                                color="primary"
                                onClick={() => setIsShowDialogRestoreTicket(true)}
                            >
                                {trI18n('RESTORE')}
                            </Button>
                        </div>
                    )}
                </div>

                {/* Popup confirm cancel */}
                <ConfirmDialog
                    isOpen={displayPopupConfirmCancel}
                    msgConfirm={trI18n('MSG-CM-CONFIRM-CANCEL-DATA-CHANGE')}
                    textSubmit={trI18n('CM-BUTTON-OK')}
                    okCallBack={e => handleConfirmCancelEdit()}
                    textClose={trI18n('CM-BUTTON-CANCEL')}
                    closeCallBack={() => setDisplayPopupConfirmCancel(false)}
                />
            </div>
        )
    );
}
